import {GoogleMap, Marker, Polyline, useLoadScript} from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "400px"
};

export default function GpsMap({logs = []}) {

    const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;


    console.log("Google Map Key:", apiKey);

    const {isLoaded} = useLoadScript({
            googleMapsApiKey:process.env.REACT_APP_GOOGLE_MAP_KEY,

    });



    if (!isLoaded) {

        return (

            <div>
                Loading map...
            </div>

        );

    }





    if (!logs.length) {

        return (

            <div>
                No GPS data available
            </div>

        );

    }




    const center = {

        lat:
            Number(logs[0].latitude),

        lng:
            Number(logs[0].longitude)

    };



    const path =
        logs.map(
            (item) => ({

                lat: Number(item.latitude),

                lng: Number(item.longitude)

            })
        );





    return (

        <GoogleMap

            mapContainerStyle={
                containerStyle
            }

            center={
                center
            }

            zoom={14}

        >


            {

                logs.map(
                    (log, index) => (


                        <Marker

                            key={log.id}

                            position={{

                                lat: Number(log.latitude),

                                lng: Number(log.longitude)

                            }}

                            label={`${index + 1}`}

                        />


                    )

                )

            }



            <Polyline

                path={path}

            />


        </GoogleMap>


    );


}